import Loadable from 'react-loadable';

export const HowToPage = Loadable<any, any>({
  loader: () => import(/* webpackChunkName: "HowToPage" */ './HowToPage'),
  loading: () => null,
});

export { howToResource } from './resources/howToResource';
